<ng-template #toolbarActions>
  @if (isImage) {
    <button class="btn btn-light btn-sm" type="button" (click)="zoomOut()">
      <i class="bi bi-zoom-out" aria-hidden="true"></i>
    </button>
    <button class="btn btn-light btn-sm" type="button" (click)="zoomIn()">
      <i class="bi bi-zoom-in" aria-hidden="true"></i>
    </button>
    <button class="btn btn-light btn-sm" type="button" (click)="fitToWidth()">
      <i class="bi bi-arrows-angle-expand" aria-hidden="true"></i>
      <span class="toolbar-label">{{ translations.fitWidth }}</span>
    </button>
    <button class="btn btn-light btn-sm" type="button" (click)="fitToScreen()">
      <i class="bi bi-aspect-ratio" aria-hidden="true"></i>
      <span class="toolbar-label">{{ translations.fit }}</span>
    </button>
    <button class="btn btn-light btn-sm" type="button" (click)="rotate()">
      <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
    </button>
  }
  <button class="btn btn-light btn-sm" type="button" (click)="openInNewTab()">
    <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
  </button>
  <button class="btn btn-primary btn-sm" type="button" (click)="download()">
    <i class="bi bi-download" aria-hidden="true"></i>
    <span class="toolbar-label">{{ translations.download }}</span>
  </button>
</ng-template>

@if (data; as viewerData) {
  <div class="header-page">


    <div class="header-title" [title]="viewerData.name">
      {{ viewerData.name }}
    </div>

    <div class="viewer-toolbar viewer-toolbar--desktop">
      <ng-container [ngTemplateOutlet]="toolbarActions" />
    </div>
  </div>

  <div class="viewer-toolbar viewer-toolbar--mobile">
    <ng-container [ngTemplateOutlet]="toolbarActions" />
  </div>

  <div class="page-content">
    @switch (viewerData.kind) {
      @case ('image') {
        <app-file-viewer-image
          [isComponent]="true"
          [src]="viewerData.src"
          [name]="viewerData.name"
          [languageCode]="viewerData.languageCode"
        />
      }
      @case ('pdf') {
        <app-file-viewer-pdf
          [isComponent]="true"
          [src]="viewerData.src"
          [name]="viewerData.name"
          [languageCode]="viewerData.languageCode"
        />
      }
      @case ('video') {
        <app-file-viewer-video
          [isComponent]="true"
          [src]="viewerData.src"
          [name]="viewerData.name"
          [languageCode]="viewerData.languageCode"
        />
      }
    }
  </div>
} @else {
  <div class="page-empty">{{ translations.fileFallbackName }}</div>
}
